<template>
    <ContentWrapper>
        <div>
            <table class="table table-striped table-hover" style="text-align:center;">
                <thead>
                    <tr>
                        <td></td>
                        <td>교재명</td>
                        <td>저자</td>
                        <td>저작권</td>
                    </tr>
                </thead>
                <tr v-if="data.list.length == 0 || data.list.length == null ">
                    <td colspan="4" class="text-center">No matching records</td>
                </tr>
                <tr v-for="item in  data.list" :key="item.contSeq">
                    <td style="vertical-align: middle; border: 1px solid #e9edef;">
                        <input type="radio" class="form-control" name="anniversary" style="width:20px;" @click="seleteDate(item)">
                    </td>
                    <td style="vertical-align: middle; border: 1px solid #e9edef;" >{{item.textbookNm}} </td>
                    <td style="vertical-align: middle; border: 1px solid #e9edef;" >{{item.author}} </td>
                    <td style="vertical-align: middle; border: 1px solid #e9edef;" >{{item.license}} </td>
                </tr>
            </table>
            <div class="footer">
              <div class="float-right">
                  <b-button @click="close()" class="btn btn-b btn-outline-danger mr-2" variant="outline-info mr-2">취소</b-button>
                  <b-button @click="save()" class="btn btn-b btn-info mr-2" variant="info mr-2">저장</b-button>
              </div>
            </div>
       </div>
   </ContentWrapper>
</template>

<script>
import Vue from 'vue';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/ko'
import 'element-ui/lib/theme-chalk/index.css';
import {reactive, ref, computed, onMounted, onUnmounted, onBeforeMount} from '@vue/composition-api'
import {getStudyCheck,saveCheckStudy,getStudyLmTextBook} from "@/api/exhibit/studycheck/StudyCheckApi"
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import {dataObject,purpTypeCd, fileTypeCd, fileDivCdMap, aws_cdn_path} from "@/utils/Constants";
import VCalendar from 'v-calendar';
import Axios from 'axios';

Vue.use(VCalendar, {
    componentPrefix: 'vc'
});
Vue.use(ElementUI, { locale });

export default {
  components: {Pagenation,VCalendar},
  props:{
      schLevelSubOption:'',
      schLevelOption : '',
  },
  setup(props,context) {
      const seleteData = ref(); //선택된 교과서 객체 
      const subOption = props.schLevelSubOption;
      const data = reactive({
          list: [],
      });
     
     const loadData = async() => { //갖고온 데이터로 검색해주기
        let result = await getStudyLmTextBook({
            subjectCd : subOption.text,
            grade : props.schLevelOption.text,
        });
        data.list = result.data
     }

      const seleteDate = (item) => {  //교과서 선택
        seleteData.value = item; 
       } 

      const close = () =>{
        context.emit('modal-state', 'findtxt' );
      }

      const save = () =>{
        context.emit('set-txt', seleteData.value );
      }

       


    onMounted(loadData)
    return {
        data,
        seleteDate,
        seleteData,
        subOption,
        close,
        save,
        ...methods(),
    }
  },
}

function methods() {
  var context = {};
  context["getStudyLmTextBook"] = saveCheckStudy; // get textbookContents list  

  return {}
}

</script>
